import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { Post } from '../container';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-postsearchpopup',
    templateUrl: './postsearchpopup.component.html',
    styleUrls: ['./postsearchpopup.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule],
})
export class PostsearchpopupComponent {
  @Input() organizationKey = ""
  @Input() projectKey = ""
  @Input() userId = ""
  @Input() userEmail = ""
  @Input() userName = ""
  @Input() canAddNewContent = false
  @Output() foundContent = new EventEmitter<{"key": string, "name": string, "htmlName": string, "color": string, "coverImageURL": string}[]>();
  @Output() addNewPost = new EventEmitter<void>();

  showModal = true
  posts: Post[] = []
  postsBeforeFiltering: Post[] = [] // array of all posts before filtering, used to recover posts when filtering is cleared without reloading
  userQuery = ""
  message = ""
 // postsChecked: {"key": string, "checked": boolean}[] = []
  showFavouriteOnly = false

  constructor(private firestore: FirestoreService) {

  }

  ngAfterViewInit() {
    setTimeout(() => { // it must be wrapped with setTimeout to avoid error
      this.loadPosts()
    })
  }

  filterOnInputChange(value: string) { // detect that user cleared filtering input field
    if (value.trim() === '') {
      this.filterPosts("")
    }
  }

  showFavourite(showOnly: boolean) {
    this.showFavouriteOnly = showOnly
    this.filterPosts(this.userQuery)
  }

  filterPosts(searchQuery: string) { // filters posts by keywords
    this.message = "Searching posts..."
    if (searchQuery != "") { // if user didn't enter text, then don't filter
      const searchWords: string[] = searchQuery.toLowerCase().split(/[,\s.:-;\n]+/);
      this.posts = this.postsBeforeFiltering.filter((obj: Post) => {
        return searchWords.some((word: string) => (obj.name.toLowerCase() || '').includes(word));
      }).map(obj => ({...obj}));
    } else { // if user entered text, then filter
      this.posts = this.postsBeforeFiltering.map(obj => ({...obj}));
    }
    if (this.posts.length == 0) {
      this.message = "No matching content found."
    }
    if (this.showFavouriteOnly == true) {
      this.posts = this.posts.filter(obj => obj.isFavourite == true) // Filter for favorite posts
      .map(obj => ({...obj}));
    }
  }

  loadPosts() {
    this.posts.length = 0
   // this.postsChecked.length = 0
    this.message = "Loading content..."
    this.firestore.getContentByType(this.organizationKey, this.projectKey, "post").then((result) => {
      this.posts = [...result]
      if (this.posts.length == 0) {
        this.message = "No matching content found"
      }
   /*   for (let i = 0; i< this.posts.length; i++) {
        this.postsChecked.push({"key": this.posts[i].key, "checked": false})
      }*/
      this.postsBeforeFiltering = this.posts.map(obj => ({...obj}));
    })
  }
  
    closeModal() { // closing modal window is done by changing parameter showModal on parent component
      this.foundContent.emit([]);
    }

    checkName(key: string) {
      const i = this.getPostByKey(key)
      if (i > -1) {
        this.posts[i].isNewPost = !this.posts[i].isNewPost
      }
    }

    getPostByKey(key: string) {
      for (let i = 0; i < this.posts.length; ++i) {
        if (this.posts[i].key == key) {
          return i
        }
      }
      return -1
    }

    addPosts() {
      const posts: {"key": string, "name": string, "htmlName": string, "color": string, "coverImageURL": string}[] = []
      for (let i = 0; i < this.posts.length; i++) {
        if (this.posts[i].isNewPost == true) {
          posts.push({"key": this.posts[i].key, "name": this.posts[i].nameHTML, "htmlName": this.posts[i].nameHTML, "color": this.posts[i].color, "coverImageURL": this.posts[i].coverImageURL})
        }
      }
      this.foundContent.emit(posts);
    }

    sendAddNewPost() {
      this.addNewPost.emit()
    }

}
